export const COURSE_DETAIL_UPSELL_TRACKS = {
  RENDER: 'course_detail_upsell__render',
  BUY: 'course_detail_upsell__buy',
  SWITCH_PROMO: 'course_detail__switch_promo',
};
